module.exports = __webpack_public_path__ + "img/nine.82dcc371.png";